/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResetPccPushStatus200ResponseData } from './ResetPccPushStatus200ResponseData';
import {
    ResetPccPushStatus200ResponseDataFromJSON,
    ResetPccPushStatus200ResponseDataFromJSONTyped,
    ResetPccPushStatus200ResponseDataToJSON,
} from './ResetPccPushStatus200ResponseData';

/**
 * 
 * @export
 * @interface ResetPccPushStatus200Response
 */
export interface ResetPccPushStatus200Response {
    /**
     * 
     * @type {ResetPccPushStatus200ResponseData}
     * @memberof ResetPccPushStatus200Response
     */
    data?: ResetPccPushStatus200ResponseData;
}

/**
 * Check if a given object implements the ResetPccPushStatus200Response interface.
 */
export function instanceOfResetPccPushStatus200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResetPccPushStatus200ResponseFromJSON(json: any): ResetPccPushStatus200Response {
    return ResetPccPushStatus200ResponseFromJSONTyped(json, false);
}

export function ResetPccPushStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPccPushStatus200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ResetPccPushStatus200ResponseDataFromJSON(json['data']),
    };
}

export function ResetPccPushStatus200ResponseToJSON(value?: ResetPccPushStatus200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ResetPccPushStatus200ResponseDataToJSON(value.data),
    };
}

